import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { getPageName } from '../../../utils/pageName';
import {
  withLoginModal,
  WithLoginModalProps,
} from '../../../login/withLoginModal';
import styles from './search_restriction.module.scss';

type Props = WithLoginModalProps;

export const RawSearchRestriction: FC<Props> = ({ openLoginModal }) => {
  const sourcePage = getPageName();

  const source = 'search-restriction';

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <i className={`material-icons icons__lock ${styles.icon}`} />
        <div className={styles.title}>
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/1" />
          <br />
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/2" />
        </div>
        <Hyperlink
          className={`button large brand ${styles.startButton}`}
          href={`/inscription?source=${source}&sourcePage=${sourcePage}`}
        >
          <i
            className={`material-icons icons__arrow_forward ${styles.arrow}`}
          />
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/3" />
        </Hyperlink>
        <div className={styles.connexion}>
          <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/4" />
          <button
            type="button"
            className={styles.connexionLink}
            onClick={() => openLoginModal(source)}
          >
            <FormattedMessage id="search/components/search-restriction/SearchRestriction.tsx/5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export const SearchRestriction = withLoginModal(RawSearchRestriction);
